export interface ParsedRow {
  [key: string]: string;
}

export interface MappedContact {
  firstName: string;
  lastName: string;
  email: string;
  linkedinUrl: string;
  title: string;
  company: string;
  industry: string;
  country: string;
  event: string;
  notes: string;
  tags: string;
}

export interface ImportRow {
  index: number;
  raw: ParsedRow;
  mapped: MappedContact;
  status: 'valid' | 'duplicate' | 'error';
  duplicateReason?: string;
  errors?: string[];
}

export interface ColumnMapping {
  csvColumn: string;
  contactField: keyof MappedContact | '';
}

export const CONTACT_FIELDS: { key: keyof MappedContact; label: string; required?: boolean }[] = [
  { key: 'firstName', label: 'First Name', required: true },
  { key: 'lastName', label: 'Last Name', required: true },
  { key: 'email', label: 'Email' },
  { key: 'linkedinUrl', label: 'LinkedIn URL' },
  { key: 'title', label: 'Job Title' },
  { key: 'company', label: 'Company' },
  { key: 'industry', label: 'Industry' },
  { key: 'country', label: 'Country' },
  { key: 'event', label: 'Event' },
  { key: 'notes', label: 'Notes' },
  { key: 'tags', label: 'Tags (comma-separated)' },
];

// LinkedIn CSV export column name mappings
export const LINKEDIN_COLUMN_MAP: Record<string, keyof MappedContact> = {
  'first name': 'firstName',
  'firstname': 'firstName',
  'given name': 'firstName',
  'last name': 'lastName',
  'lastname': 'lastName',
  'surname': 'lastName',
  'family name': 'lastName',
  'email address': 'email',
  'email': 'email',
  'e-mail': 'email',
  'linkedin profile url': 'linkedinUrl',
  'profile url': 'linkedinUrl',
  'linkedin url': 'linkedinUrl',
  'url': 'linkedinUrl',
  'position': 'title',
  'title': 'title',
  'job title': 'title',
  'current position': 'title',
  'company': 'company',
  'organization': 'company',
  'employer': 'company',
  'current company': 'company',
  'industry': 'industry',
  'country': 'country',
  'location': 'country',
  'region': 'country',
  'event': 'event',
  'notes': 'notes',
  'note': 'notes',
  'tags': 'tags',
  'label': 'tags',
  'connected on': '',
};

export type ImportStep = 'upload' | 'mapping' | 'preview' | 'done';
